export function checkDateYM(date) {
    var check = false;
    var chk_date = date.split("/");
    if(chk_date.length === 2){
        var chk_year = chk_date[0];
        var chk_month = chk_date[1];
        if (chk_year != "0000" && chk_year.length === 4 &&
            chk_month != "00" && chk_month.length < 3  && chk_month > 0 && chk_month < 13) {
            check = true;
        }
    }
    return check;
}